import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, map } from 'lodash/fp'
import { GraphHeatmap, IGraphBin } from 'features/CallAnalytics/GraphHeatmap'
import moment from 'moment'
import { mapWithKey } from '../../../../utils/lodash'
import { ICall } from 'features/CallAnalytics/types'

const formatData = flow<ICall[], any, any, any, IGraphBin[]>(
  map((call: ICall) => {
    const date = moment(call.dateTime)
    return {
      day: date.local().format('e'),
      hour: date.local().format('HH'),
    }
  }),
  // Group the items
  groupBy('day'),
  map(groupBy('hour')),
  // Change them to the bin format
  mapWithKey((dayGroup, day) => ({
    bin: day,
    bins: mapWithKey(
      (hourGroup, hour) => ({
        bin: parseInt(hour, 10),
        count: hourGroup.length,
        day,
        hour,
      }),
      dayGroup
    ),
  }))
)

export const CallsByTimeOfDayHeatmap = ({
  calls,
  loading,
}: {
  calls: ICall[]
  loading: boolean
}) => {
  const data = formatData(calls)
  return (
    <InfoCard
      style={{ height: '100%' }}
      title="Calls by time of day"
      loading={loading}
      allowOverflow
    >
      <ParentSize>
        {({ width }) => <GraphHeatmap width={width} height={400} data={data} />}
      </ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsByTimeOfDayHeatmap/CallsByTimeOfDayHeatmap.tsx